module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Name","completed":"Completed sectors","total":"Total sectors"},"ko":{"name":null,"completed":null,"total":null}}')
  delete Component.options._Ctor
}
